import "./style.scss";
import * as React from "react";
import { Form, Button } from "antd";
import ReportEndpoint from "./ReportEndpoint";
import ReportSchedule from "./ReportSchedule";
import ReportContact from "./ReportContact";

const NAVIGATE_BACK = 0;
const NAVIGATE_NEXT = 1;

class StageTwo extends React.Component<any, any> {
  handleSubmit(event: number, e: EventTarget) {
    switch (event) {
      case NAVIGATE_BACK:
        this.props.back();
        break;
      case NAVIGATE_NEXT:
        this.props.form.validateFieldsAndScroll((err: any, values: any) => {
          if (!err) this.props.next();
          else console.warn("Stage two not valid!");
        });
        break;
      default:
        console.warn("Implement route change");
        break;
    }
  }

  render() {
    return (
      <div className="stage-two">
        <ReportEndpoint
          toggleSftp={this.props.toggleSftp}
          toggleEmail={this.props.toggleEmail}
          toggleFtp={this.props.toggleFtp}
          editEndpoint={this.props.editEndpoint}
          form={this.props.form}
          {...this.props.endpoint}
        />

        <ReportSchedule
          toggleDaily={this.props.toggleDaily}
          toggleWeekly={this.props.toggleWeekly}
          toggleMonthly={this.props.toggleMonthly}
          editDay={this.props.editDay}
          editTime={this.props.editTime}
          editStart={this.props.editStart}
          editTimezone={this.props.editTimezone}
          toggleEnabled={this.props.toggleEnabled}
          form={this.props.form}
          {...this.props.schedule}
        />

        <ReportContact
          editContacts={this.props.editContacts}
          contacts={this.props.contacts}
          form={this.props.form}
        />

        <Button
          type="primary"
          onClick={this.handleSubmit.bind(this, NAVIGATE_NEXT)}
          className="next"
        >
          Next
        </Button>

        <Button
          type="primary"
          onClick={this.handleSubmit.bind(this, NAVIGATE_BACK)}
          className="back"
        >
          Back
        </Button>
      </div>
    );
  }
}

export default Form.create()(StageTwo);



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageTwo/component.tsx